import { JavascriptApi } from "../widgets/javascriptApi/javascriptApi.js";

let fdJavascriptApi = document.getElementById('fdJavascriptApi');
let opts = {};
let fdJavascriptApiWidget = new JavascriptApi(fdJavascriptApi, opts);